import "@lds/core/lds-video-player.js"

export default class StarsVideos {
    /**
     * @typedef {ldsVideoPlayer} VideoPlayer
     * @property {videojs.VideoJsPlayer} player
     */

    /**
     * @property {Array<VideoPlayer>} StarsVideos.players
     */
    constructor() {
        this.players = []
    }

    /**
     * @return {Array<VideoPlayer>}
     */
    videoPlayers() {
        return this.players
    }

    updateLDSVideoPlayerData(/** string= */ bClass) {
        /** void */
        const baseClass = bClass || ".pic-galerie .swiper"

        const videoPlaceholders = document.querySelectorAll(`${baseClass} div.wc-video`)

        for (const videoPlaceholder of videoPlaceholders) {
            this.generateLDSVideoPlayers(videoPlaceholder)
        }
    }

    /**
     * @private
     */
    generateLDSVideoPlayers(/** HTMLDivElement */ videoPlaceholder) {
        /** void */
        // New instance of a ldsVideoPlayer-tag
        const ldsVideoPlayer = document.createElement("lds-video-player")

        // Copy over all attributes to the new tag
        for (const attribute of Array.from(videoPlaceholder.attributes)) {
            this.copyVideoAttributes(ldsVideoPlayer, attribute)
        }

        // Replace the placeholder tag with the actual video
        videoPlaceholder.parentNode.replaceChild(ldsVideoPlayer, videoPlaceholder)

        ldsVideoPlayer.addEventListener("ready", (readyEvent) => this.addVideoPlayerEventListeners(readyEvent))

        // Keep a list of all instances
        this.players.push(ldsVideoPlayer)
    }

    /**
     * @private
     */
    copyVideoAttributes(/** ldsVideoPlayer */ videoPlayer, /** Attr */ attribute) {
        /** void */
        switch (attribute.nodeName) {
            case "data-options":
                // Move value from data-*-attribute to actual attribute
                videoPlayer.setAttribute("options", attribute.nodeValue)
                break

            case "data-poster":
                // Move value from data-*-attribute to actual attribute
                videoPlayer.setAttribute("posterUrl", attribute.nodeValue)
                break

            case "data-headers":
                // Move value from data-*-attribute to actual attribute
                videoPlayer.headers ??= []
                videoPlayer.headers.push(JSON.parse(attribute.nodeValue))
                break

            default:
                // All other attributes can be copied as-is
                videoPlayer.setAttribute(attribute.nodeName, attribute.nodeValue)
                break
        }
    }

    addVideoPlayerEventListeners(/** Event */ readyEvent) {
        /** void */
        const ldsVideoPlayer = readyEvent.target

        ldsVideoPlayer.player.one("play", () => this.addClassForInitializedVideosToSlide(ldsVideoPlayer))
    }

    addClassForInitializedVideosToSlide(/** ldsVideoPlayer|Element */ ldsVideoPlayer) {
        /** void */
        const swiperSlide = ldsVideoPlayer.closest(".swiper-slide")

        if (swiperSlide !== null) {
            swiperSlide.classList.add("player-initialized")
        }
    }
}
